/**
 * Redux actions for running orders.
 * @module redux/actions/runningOrder
 */

import { createAction } from 'redux-actions';
import {
  getRunningOrdersList as apiGetRunningOrdersList,
  getRunningOrder as apiGetRunningOrder
} from '../api/runningOrder';

export const REQUEST_RUNNING_ORDER = 'RUNNING_ORDER/REQUEST_RUNNING_ORDER';
export const RUNNING_ORDER_REQUEST_FAILED = 'RUNNING_ORDER/RUNNING_ORDER_REQUEST_FAILED';
export const RUNNING_ORDER_RECEIVED = 'RUNNING_ORDER/RUNNING_ORDER_RECEIVED';
export const REQUEST_RUNNING_ORDERS_LIST = 'RUNNING_ORDER/REQUEST_RUNNING_ORDERS_LIST';
export const RUNNING_ORDERS_LIST_REQUEST_FAILED =
  'RUNNING_ORDER/RUNNING_ORDERS_LIST_REQUEST_FAILED';
export const RUNNING_ORDERS_LIST_RECEIVED = 'RUNNING_ORDER/RUNNING_ORDERS_LIST_RECEIVED';
export const SELECT_STORY = 'RUNNING_ORDER/SELECT_STORY';

const requestRunningOrder = () => createAction(REQUEST_RUNNING_ORDER);
const runningOrderReceived = runningOrder =>
  createAction(RUNNING_ORDER_RECEIVED)({
    runningOrder: {
      ...runningOrder,
      stories: runningOrder.stories.filter(s => s.name !== 'All Stories')
    }
  });
const runningOrderRequestFailed = () => createAction(RUNNING_ORDER_REQUEST_FAILED);
const runningOrdersListReceived = runningOrdersList =>
  createAction(RUNNING_ORDERS_LIST_RECEIVED)({ runningOrdersList });
const runningOrdersListRequestFailed = () => createAction(RUNNING_ORDERS_LIST_REQUEST_FAILED);
const requestRunningOrdersList = () => createAction(REQUEST_RUNNING_ORDERS_LIST);
export const selectStory = selectedStoryId => createAction(SELECT_STORY)({ selectedStoryId });

/**
 * Gets a list of running orders.
 */
export function getRunningOrdersList() {
  return dispatch => {
    dispatch(requestRunningOrdersList());
    return apiGetRunningOrdersList()
      .then(runningOrdersList => dispatch(runningOrdersListReceived(runningOrdersList)))
      .catch(error => {
        console.log(error);
        return dispatch(runningOrdersListRequestFailed());
      });
  };
}

/**
 * Loads a specific running order specified by its id.
 * @param  {string} runningOrderId The id of the running order to load.
 */
export function getRunningOrder(runningOrderId) {
  return dispatch => {
    dispatch(requestRunningOrder());
    return apiGetRunningOrder(runningOrderId)
      .then(runningOrder => dispatch(runningOrderReceived(runningOrder)))
      .catch(error => {
        console.log(error);
        return dispatch(runningOrderRequestFailed());
      });
  };
}

export const actions = {
  getRunningOrder,
  getRunningOrdersList,
  selectStory
};



// WEBPACK FOOTER //
// ./app/actions/runningOrder.js